import {ViewOptions} from 'backbone';

import * as asserts from 'Asserts';
import Protein from 'molbio/proteins/Protein';
import ProteinActions from 'molbio/proteins/ProteinActions';
import {ProteinUpdateData} from 'molbio/proteins/ProteinDAO';
import BasicInformationPanelView from 'toolbar/shared/BasicInformationPanelView';

class ProteinInformationPanelView extends BasicInformationPanelView<Protein> {
  constructor(...args: Array<ViewOptions<Protein>>) {
    super(...args);
    this.saveModel = this.saveModel.bind(this);
    this.deleteModel = this.deleteModel.bind(this);
    this.getDownloadInfo = this.getDownloadInfo.bind(this);
  }

  saveModel(data: ProteinUpdateData): void {
    ProteinActions.update(this.model.id, data, {success: this.onSaveSuccess});
  }

  deleteModel(): void {
    ProteinActions.delete(this.model.id, {success: this.onDeleteSuccess});
  }

  getDownloadInfo(): Array<{url: string; title: string}> {
    const editUrl = this.model.editURL();
    asserts.assertAndContinue(editUrl.slice(-5) === '/edit', 'Expected edit URL to end with /edit.');
    return [
      {
        url: editUrl.replace(/\/edit$/, '.fasta'),
        title: 'FASTA (.fasta)',
      },
      {
        url: editUrl.replace(/\/edit$/, '.gp'),
        title: 'GenPept (.gp)',
      },
    ];
  }
}

export default ProteinInformationPanelView;
